import { schemaItems } from './schemaItems';

export const workflowSteps = ($http: HttpApi) => ({
  // nested resources
  schemaItems: schemaItems($http),
});
